import Blogs from "./blogs";

export default function Articles() {
    return (
        <>
            <section className="  my-16 ">
                <Blogs />
            </section>
        </>
    );
}
